import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const PasswordInputContainer = styled.div(
	({ theme }) => css`
		position: relative;
		margin-top: 16px;

		.password_input {
			width: 100%;

			& > div {
				grid-template-columns: auto 1fr auto auto;
			}
		}

		.password_validator {
			box-shadow: 0px 4px 24px 0px #00000029;
			position: absolute;
			left: 0;
			top: 68px;
			width: 100%;
			padding: 16px;
			border-radius: 8px;
			background: ${theme.colors.background.popup};
			display: flex;
			flex-direction: column;
			gap: 4px;
			z-index: 2;

			.validator_item {
				display: flex;
				align-items: center;
				gap: 4px;

				svg {
					width: 12px;
					height: 12px;
					color: ${theme.colors.text.tertiary};
				}

				span {
					font-weight: 400;
					line-height: 15px;
					font-size: 13px;
					color: ${theme.colors.text.secondary};
				}

				&.active {
					svg {
						color: ${theme.colors.text.success};
					}

					span {
						color: ${theme.colors.text.primary};
					}
				}
			}
		}

		@media (min-width: 840px) {
			.password_validator {
				left: calc(100% + 8px);
				top: 23px;
				width: 300px;

				&.right {
					left: calc(100% + 8px);
					top: 23px;
				}
				&.bottom {
					left: auto;
					right: 0;
					top: 68px;
				}
			}
		}
	`,
);
